import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { num: 2007, suffix: '', label: 'Year Founded', sub: '18+ years of excellence' },
  { num: 30, suffix: '+', label: 'Professionals', sub: 'Skilled engineers & staff' },
  { num: 4, suffix: '', label: 'Core Divisions', sub: 'Multi-disciplinary firm' },
  { num: 2, suffix: '', label: 'State Offices', sub: 'Abuja FCT · Osun State' },
  { num: 5, suffix: '+', label: 'Certifications', sub: 'CAC · SCUML · ITF · EFCC' },
];

function CountUp({ target, suffix, active }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    const duration = 1800;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(current));
    }, duration / steps);
    return () => clearInterval(timer);
  }, [active, target]);
  return <>{count}{suffix}</>;
}

export default function StatsBar() {
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setActive(true); obs.disconnect(); } }, { threshold: 0.3 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ background: 'var(--blue)', display: 'flex', flexWrap: 'wrap' }}>
      {stats.map((s, i) => (
        <div key={i} style={{
          flex: '1 1 160px',
          padding: '1.6rem 2rem',
          display: 'flex', alignItems: 'center', gap: '1.2rem',
          borderRight: i < stats.length - 1 ? '1px solid rgba(255,255,255,0.18)' : 'none',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
          animation: active ? `countUp 0.5s ease ${i * 0.1}s both` : 'none',
        }}>
          <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.6rem', color: 'white', lineHeight: 1, minWidth: '3rem' }}>
            <CountUp target={s.num} suffix={s.suffix} active={active} />
          </div>
          <div>
            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.8rem', fontWeight: 700, color: 'white', textTransform: 'uppercase', letterSpacing: '0.1em' }}>{s.label}</div>
            <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.7)', fontWeight: 300, marginTop: 2 }}>{s.sub}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
